import Theme from 'Theme';
import { StyleSheet } from 'react-native';

const baseStyles = {
    container: {
        flex: 1
    },
    switchWrapper: {
        paddingVertical: 15,
        paddingHorizontal: 6,
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center'
    },
    label: {
        fontFamily: Theme.regularFont,
        color: Theme.primaryTextColor,
        fontSize: 20,
        paddingRight: 20,
        flexShrink: 1
    }
};

export default StyleSheet.create(baseStyles);
